import {
  ScrollText,
  MapPinned,
  Mailbox,
  ShieldCheck,
  Users,
  Sparkles,
} from "lucide-react";
import { useTranslation } from "react-i18next";

// Icons stay hardcoded — they're presentational. Titles + bodies are
// pulled from i18n at render time so each card re-renders when the user
// toggles languages.
const FEATURE_KEYS = [
  { key: "clues", icon: ScrollText },
  { key: "spiritMap", icon: MapPinned },
  { key: "letters", icon: Mailbox },
  { key: "control", icon: ShieldCheck },
  { key: "everywhere", icon: Users },
  { key: "coalie", icon: Sparkles },
] as const;

export function FeatureHighlights() {
  const { t } = useTranslation();
  return (
    <section
      id="features"
      className="relative px-5 py-12 sm:px-8 sm:py-16 lg:px-12 lg:py-20"
      data-testid="section-features"
    >
      <div className="mx-auto max-w-7xl">
        <div className="jingle-reveal mx-auto max-w-2xl text-center">
          <p className="inline-flex items-center gap-3 text-[11px] font-semibold uppercase tracking-[0.32em] text-jingle-gold">
            <span aria-hidden className="jingle-flourish-line" />
            <span aria-hidden className="text-jingle-gold-soft/80">✦</span>
            {t("marketing.features.eyebrow")}
            <span aria-hidden className="text-jingle-gold-soft/80">✦</span>
            <span aria-hidden className="jingle-flourish-line jingle-flourish-line--right" />
          </p>
          <h2 className="mt-3 font-serif text-4xl font-semibold tracking-tight text-jingle-snow sm:text-5xl">
            {t("marketing.features.heading")}
          </h2>
          <p className="mt-4 text-base leading-relaxed text-jingle-snow/75">
            {t("marketing.features.subhead")}
          </p>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {FEATURE_KEYS.map((f, i) => {
            const Icon = f.icon;
            return (
              <div
                key={f.key}
                className="jingle-reveal jingle-card-pine jingle-lift rounded-2xl p-5"
                style={{ transitionDelay: `${i * 50}ms` }}
              >
                <div className="flex items-center gap-3">
                  <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-jingle-gold/15 text-jingle-gold">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="font-serif text-lg font-semibold text-jingle-snow">
                    {t(`marketing.features.${f.key}.title`)}
                  </h3>
                </div>
                <p className="mt-2.5 text-sm leading-relaxed text-jingle-snow/70">
                  {t(`marketing.features.${f.key}.body`)}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
